import { render, staticRenderFns } from "./210.vue?vue&type=template&id=216faf0f&scoped=true&"
var script = {}
import style0 from "./210.vue?vue&type=style&index=0&id=216faf0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216faf0f",
  null
  
)

export default component.exports